import { client } from './claims';

export interface FoaPreviewClaim {
  id: string;
  lenderName: string;
  vehicle: string;
  currentFoaUrl: string | null;
  status: string;
  lastSubmission: {
    submittedAt: string;
    hasSignature: boolean;
    hasRequestId: boolean;
    loaRequestId: string;
  };
  totalSubmissions: number;
}

export interface FoaRegenerationPreview {
  clientName: string;
  clientEmail: string;
  totalClaims: number;
  eligibleClaims: number;
  claims: FoaPreviewClaim[];
}

export interface FoaRegenerationResultItem {
  claimId: string;
  success: boolean;
  newFoaUrl?: string;
  newFinalBillUrl?: string;
  regenerationId?: string;
  error?: string;
}

export interface FoaRegenerationResult {
  results: FoaRegenerationResultItem[];
  totalProcessed: number;
  succeeded: number;
  failed: number;
}

export const previewFoaRegeneration = (email: string) =>
  client.post<FoaRegenerationPreview>('/ui/admin/regenerate-foa/preview', { email }).then(res => res.data);

export const executeFoaRegeneration = (email: string, claimIds?: string[]) =>
  client.post<FoaRegenerationResult>('/ui/admin/regenerate-foa/execute', { email, claim_ids: claimIds }, { timeout: 300000 }).then(res => res.data);
